export default __webpack_public_path__ + "static/media/Radomir Tinkov - Gilroy-SemiBold.017ff10c.otf";